var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',{staticClass:"full-page-carousel",attrs:{"height":"100%","hide-controls":"","hide-delimiters":""}},[_vm._l((_vm.validImages),function(img,i){return _c('v-carousel-item',{key:i},[_c('img',{attrs:{"src":img}})])}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8595b72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/FullPageCarousel.vue
// module id = null
// module chunks = 